import { Injectable } from '@angular/core';
import { urlServices } from 'src/app/griviance/models/url.models';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class SecHeadAgendaService {

  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService, public serverURL: ServerURLService) { }

  createAgenda(data: any) {
    return this.http.post(this.url.createAgenda, data);
  }

  getAgendaList(data: any, pageId: number, rowId: number) {
    return this.http.get(this.url.getAgendaList + '?sectionId=' + data + '&page=' + pageId + '&rows=' + rowId);
  }

  getSecExeAgendaList(data: any, pageId: number, rowId: number) {
    return this.http.get(this.url.getSecExeAgendaList + '?sectionId=' + data + '&page=' + pageId + '&rows=' + rowId);
  }

  getAgendaDetailsById(agendaId: any) {
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(agendaId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getAgendaDetailsById + '?agendaIdEncr=' + agendaIdEncr)
  }

  updateAgendaDetails(data: any) {
    return this.http.post(this.url.updateAgendaDetails,data)

  }

  getMeetingList() {
    return this.http.get(this.url.getMeetingList)

  }

  getSubSectionBySectionId() {
    const sectionIdEncr = encodeURIComponent(this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getSubSectionBySectionId + '?sectionIdEncr=' + sectionIdEncr)
  }

 
  getAgendaItemNumberBySectionId(data: any){
    return this.http.get(this.url.getAgendaItemNumberBySectionId + '?sectionId=' + data)
  }

  getAgendaItemNumberBySectionIdandmeetingId(data: any,meetingId : any){
    return this.http.get(this.url.getAgendaItemNumberBySectionIdandmeetingId + '?sectionId=' + data + '&meetingId=' + meetingId)
  }
  
  updateMeetingDetails(data: any){
    return this.http.post(this.url.updateMeetingDetails,data)
  }
  getAgendaItemNumberBySectionIdandMeetingIdandSubSectionId(data: any){
    return this.http.post(this.url.getAgendaItemNumberBySectionIdandMeetingIdandSubSectionId,data)
  }

  removeMeetingwithAgenda(data: any){
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(data, this.serverURL.secretKey).toString());
    const roleNameEncr = encodeURIComponent(this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString());
    return this.http.get(this.url.removeMeetingwithAgenda + '?agendaIdEncr=' + agendaIdEncr + '&roleNameEncr=' + roleNameEncr);
  }

deleteAgendaById(agendaId: number) {
  const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(agendaId, this.serverURL.secretKey).toString());
  const roleNameEncr = encodeURIComponent(this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString());
  return this.http.get(this.url.deleteAgendaById + '?agendaIdEncr=' + agendaIdEncr + '&roleNameEncr=' + roleNameEncr);
  }

  createAgendaStudent(data: any) {
    return this.http.post(this.url.createAgendaStudent, data);
  }
SendAgendaForReview(agendaId: number,comments: any,roleName : any,workflowStatus :any) {
        return this.http.get(this.url.SendAgendaForReview + '?agendaId=' + agendaId + '&comments=' + comments + '&roleName=' + roleName + '&workflowStatus=' + workflowStatus)
  }

  agendaProcessHistory(agendaId: number) {
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(agendaId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.agendaProcessHistory + '?agendaIdEncr=' + agendaIdEncr);
  }
  
  getSecretaryReviewAgendaList(pageId: number, rowId: number) {
    return this.http.get(this.url.getSecretaryReviewAgendaList + '?page=' + pageId + '&rows=' + rowId);
  }
//add by gokul
  sendSecretaryReviewBulkAgenda(checkedagendaListIDs:any, agendaComments:any,roleName:any){
    return this.http.get(this.url.sendSecretaryReviewBulkAgenda + '?checkedagendaListIDs=' + checkedagendaListIDs + '&agendaComments=' + agendaComments+ '&roleName=' + roleName);
}


//   sendPresidentReviewBulkAgenda(checkedagendaListIDs:any, agendaComments:any,roleName:any){
//     return this.http.get(this.url.sendPresidentReviewBulkAgenda + '?checkedagendaListIDs=' + checkedagendaListIDs + '&agendaComments=' + agendaComments+ '&roleName=' + roleName);
// }


//  sendFinalReviewBulkAgenda(checkedagendaListIDs:any, agendaComments:any,roleName:any){
//     return this.http.get(this.url.sendFinalReviewBulkAgenda + '?checkedagendaListIDs=' + checkedagendaListIDs + '&agendaComments=' + agendaComments+ '&roleName=' + roleName);
// }
//  sendPresidentBulkAgenda(checkedagendaListIDs:any, agendaComments:any,roleName:any){
//     return this.http.get(this.url.sendPresidentBulkAgenda + '?checkedagendaListIDs=' + checkedagendaListIDs + '&agendaComments=' + agendaComments+ '&roleName=' + roleName);
// }
//Add by gokul For secretary review 
secretaryReviewWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.secretaryReviewWithPagination, agendaSearchCriteria);
}

presidentReviewWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.presidentReviewWithPagination, agendaSearchCriteria);
}

secHeadAgendaWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.secHeadAgendaWithPagination, agendaSearchCriteria);
}

secExeAgendaListWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.secExeAgendaListWithPagination, agendaSearchCriteria);
}

sectionHeadMeetingReviewWithPagination(meetingSearchCriteria: any) {
  return this.http.post(this.url.sectionHeadMeetingReviewWithPagination, meetingSearchCriteria);
}

sendMinutesForReview(agendaId: number,comments: any,roleName : any,workflowStatus :any) {
  return this.http.get(this.url.sendMinutesForReview + '?agendaId=' + agendaId + '&comments=' + comments + '&roleName=' + roleName + '&workflowStatus=' + workflowStatus)
}

secretaryMinutesReviewWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.secretaryMinutesReviewWithPagination, agendaSearchCriteria);
}

presidentMinutesReviewWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.presidentMinutesReviewWithPagination, agendaSearchCriteria);
}

secHeadMinutesWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.secHeadMinutesWithPagination, agendaSearchCriteria);
}


minutesProcessHistory(agendaId: number) {
  return this.http.get(this.url.minutesProcessHistory + '?agendaId=' + agendaId);
}

completedMeetingAgenadaStatusListWithPagination(agendaSearchCriteria: any) {
  return this.http.post(this.url.completedMeetingAgenadaStatusListWithPagination, agendaSearchCriteria);
}

}
